import { Injectable, NgZone } from '@angular/core';
import { catchError, Observable, of, timeout } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LocationService {
	constructor(private zone: NgZone) {}

	getPosition(): Observable<{ lng: number; lat: number } | undefined> {
		return new Observable<{ lng: number; lat: number } | undefined>((observer) => {
			if (!navigator.geolocation) {
				observer.next(undefined);
				observer.complete();
				return;
			}

			navigator.geolocation.getCurrentPosition(
				(resp) => {
					this.zone.run(() => {
						observer.next({ lng: resp.coords.longitude, lat: resp.coords.latitude });
						observer.complete();
					});
				},
				(err) => {
					this.zone.run(() => {
						observer.next(undefined);
						observer.complete();
					});
				},
				{
					enableHighAccuracy: false,
					timeout: 5000,
					maximumAge: 60000,
				},
			);
		}).pipe(
			timeout(6000),
			catchError(() => of(undefined)),
		);
	}
}
